var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Label',{attrs:{"htmlFor":_vm.id,"medium":""}},[_vm._v("ログインID（メールアドレス）")]),_vm._v(" "),_c('EmailInput',{attrs:{"id":_vm.id,"width":"312"},model:{value:(_vm.inputEmail),callback:function ($$v) {_vm.inputEmail=$$v},expression:"inputEmail"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8e05cdfe","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_molecules/LabelEmailInput.vue
// module id = null
// module chunks = 